import gql from 'graphql-tag'

export default gql`
mutation ($_id: MongoID!   ){
    removeHomework(_id:$_id){
        recordId
      }
}
`